import { Link } from "react-router";
import { Toolbar } from "../../../components/Toolbar";
import { AdministrateExportButton } from "../../components/AdministrateExportButton";
import { AdministrateTable } from "../../components/AdministrateTable";
import { Routes } from "../../Routes";
import { makeColumns, useAdministrateTable, useCreatePermission } from "../../utils";
import { AddPortalCodeGroupModal } from "../components/AddPortalCodeGroupModal";
import { ImportPortalCodeGroupsModal } from "../components/ImportPortalCodeGroupsModal";
import { PortalCodeGroupActionCell } from "../components/PortalCodeGroupActionCell";

const useColumns = makeColumns(() => [
  {
    id: "code_group",
    accessor: "codeGroup.name",
    Header: "Code Group",
    Cell: ({ row, value }) => (
      <Link to={Routes.codeGroup.url(row.original.codeGroup?.id)}>
        <span className="token">{value}</span>
      </Link>
    ),
  },
  {
    id: "code_count",
    accessor: "codeCount",
    Header: "Number of Codes",
    disableSortBy: true,
  },
  {
    id: "actions",
    Header: "Actions",
    disableFilters: true,
    disableSortBy: true,
    Cell: PortalCodeGroupActionCell,
  },
]);

export const PortalCodeGroupsTab = ({ portal, portalId }) => {
  const columns = useColumns();
  const extraParams = { benefit_management_portal: { id: portalId } };
  const { tableRef, allFilters, setTableFilters } = useAdministrateTable(extraParams);
  const [canCreate] = useCreatePermission("BenefitManagementPortalCodeGroup");

  const onCreate = () => {
    const { refresh, setMessage } = tableRef.current;
    setMessage("Code Group Added");
    refresh();
  };

  const onImport = (message, details = []) => {
    const { refresh, setMessage } = tableRef.current;
    setMessage(message, details.length ? "warning" : "success", details);
    refresh();
  };

  return (
    <>
      <Toolbar className="align-items-center mb-3">
        <Toolbar className="ms-auto">
          <AdministrateExportButton
            outline
            className="me-2"
            exportUrl="/admin/benefit_management_portal_code_groups.csv"
            filters={allFilters}
          />
          {canCreate && (
            <>
              <ImportPortalCodeGroupsModal outline className="me-2" portalId={portalId} onImport={onImport} />
              <AddPortalCodeGroupModal color="primary" portal={portal} onAdd={onCreate} />
            </>
          )}
        </Toolbar>
      </Toolbar>

      <AdministrateTable
        resourceUrl={"/admin/benefit_management_portal_code_groups.json"}
        extraParams={extraParams}
        resourceName={"benefit_management_portal_code_group"}
        onFilteredChange={setTableFilters}
        columns={columns}
        ref={tableRef}
      />
    </>
  );
};
